import { gql } from 'graphql-tag'

export const DOCUMENT_UPLOAD_MODAL = gql`query documentUploadModal($number: String!) {
  policy(number: $number) {
    id
    number
    lastActiveTransaction {
      id
      paymentMethod
      isPaymentAuthorizationFormDue
    }
    currentTermLastActiveTransaction {
     location {
        state
      }
    }
  }
}`

export const EFFECTIVE_DATE_RANGE = gql`query effectiveDateRange($policyNumber: String!, $termId: Int!) {
  effectiveDateRange(policyNumber: $policyNumber, termID: $termId) {
    min
    max
  }
}`

export const AGENCY_DETAILS = gql`query Agency($agencyId: String!) {
  agency(agencyID: $agencyId) {
    id
    name
    commissionTier
    streetLine1
    streetLine2
    city
    state
    zip
    status
    revision
    shortID
    appointedStates
    autoAppointedStates
    email
    phone
    website
    notificationEmail
    reportsEmail
    commissionsEmail
    extraCommissionsEmailsArray
    principalEmail
    integrations {
      ivans {
        connected
        yAccount
        mailboxID
      }
    }
    status
    statusReason
    npn
  }
}`

export const GET_AGENCY_STATES = gql`query Agency($agencyId: String!) {
  agency(agencyID: $agencyId) {
    id
    appointedStates
    autoAppointedStates
  }
}`

export const GET_RESUMABLE_TRANSACTIONS = gql`query resumableTransactions($input: TransactionListResultsInput!) {
  transactionListResults(input: $input) {
    transactions {
      transactionUUID
      transactionID
      termID
      number
      agent {
        id
        firstName
        lastName
      }
      transactionEffectiveDate
      cumulativeWrittenPremiumCents
    }
  }
}`

export const MATCH_ACCOUNT_BY_APPLICANTS = gql`query matchAccountByApplicants($input: MatchAccountByApplicantsInput!) {
  matchAccountByApplicants(input: $input) {
    id
    name
    number
  }
}`

export const GET_POLICY_DATES = gql`query policy($number: String!, $orderBy: allowedTransactionOrderBy) {
  policy(number: $number) {
    id
    createdAt
    initialEffectiveDate
    isInTwilight
    currentTermLastActiveTransaction {
      id
      termID
      lineageTermID
      termEffectiveDate
      termExpirationDate
      transactionEffectiveDate
      agent {
      id
      }
    }
    lastActiveTransaction {
      id
      termID
      termEffectiveDate
      termExpirationDate
      transactionEffectiveDate
      action
    }
    transactions(orderBy: $orderBy) {
      id
      termID
      effectiveDate
      isReversed
    }
  }
}`
